import React from "react";
import {
  withStyles,
  Theme,
  createStyles,
  makeStyles,
} from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { ALevelTest } from "../../types/uploadTypes";
import { FilterLineItem } from "../../types/serverSideTypes";
import RoundedButton from "./PrimaryButton";
import Typography from "@material-ui/core/Typography";
import StandardAutoComplete, { Option } from "./StandardAutoComplete";

interface Props {
  tests: Array<ALevelTest>;
  setTests: (tests: Array<ALevelTest>) => void;
  testNames: Array<FilterLineItem>;
  testScores: Array<FilterLineItem>;
}

const StyledTableCell = withStyles((theme: Theme) =>
  createStyles({
    head: {
      backgroundColor: theme.palette.primary.dark,
      color: theme.palette.common.white,
      fontFamily: "SuperaGothic",
      fontWeight: "bold",
    },
    body: {
      fontSize: 16,
      fontFamily: "SuperaGothic",
      fontWeight: "normal",
    },
  })
)(TableCell);

const StyledTableRow = withStyles((theme: Theme) =>
  createStyles({
    root: {
      "&:nth-child(2n+1)": {
        //backgroundColor: theme.palette.common.black,
        backgroundColor: theme.palette.action.hover,
      },

      "& > *": {
        borderBottom: "unset",
      },
    },
  })
)(TableRow);

const useStyles = makeStyles({
  table: {
    minWidth: 700,
  },
  resize: {
    fontSize: 16,
  },
});

interface RowProps {
  test: ALevelTest;
  delete: () => void;
  setTest: (activity: ALevelTest) => void;
  options: Array<Option>;
  scores: Array<Option>;
}

function Row(props: RowProps) {
  const handleSubjectChange = (key: string | null) => {
    const newValue = Object.assign({}, props.test, {
      aLevelTestNameId: key || undefined,
    });
    props.setTest(newValue);
    //setName(event.target.value);
  };
  const handleScoreChange = (key: string | null) => {
    const newValue = Object.assign({}, props.test, {
      aLevelTestScoreId: key || undefined,
    });
    props.setTest(newValue);
    //setYearsInvolved(Number(event.target.value));
  };

  return (
    <React.Fragment>
      <StyledTableRow>
        <StyledTableCell style={{ verticalAlign: "bottom", paddingBottom: 6 }}>
          <StandardAutoComplete
            options={props.options}
            handleSelect={handleSubjectChange}
            value={props.test.aLevelTestNameId || null}
            placeholder={"A Level Business"}
          />
        </StyledTableCell>
        <StyledTableCell
          size="small"
          style={{ verticalAlign: "bottom", paddingBottom: 6 }}
        >
          <StandardAutoComplete
            options={props.scores}
            handleSelect={handleScoreChange}
            value={props.test.aLevelTestScoreId || null}
          />
        </StyledTableCell>
        <StyledTableCell>
          <RoundedButton
            variant="outlined"
            style={{ borderRadius: "30px", color: "white", border: "none" }}
            buttonStyle="secondary"
            onClick={props.delete}
          >
            <Typography
              variant="body1"
              style={{
                fontSize: "16px",
                fontFamily: "SuperaGothic",
                lineHeight: "normal",
              }}
            >
              Delete
            </Typography>
          </RoundedButton>
        </StyledTableCell>
      </StyledTableRow>
    </React.Fragment>
  );
}

export default function CustomizedTables(props: Props) {
  const classes = useStyles();

  const updateTests = (index: number, activity: ALevelTest) => {
    const newArray = props.tests.map((a) => Object.assign({}, a));
    newArray[index] = activity;
    props.setTests(newArray);
  };

  const deleteTest = (index: number) => {
    const newArray = props.tests.map((a) => Object.assign({}, a));
    newArray.splice(index, 1);
    props.setTests(newArray);
  };

  const addTest = () => {
    const newArray = props.tests.map((a) => Object.assign({}, a));
    newArray.push({
      aLevelTestNameId: undefined,
      aLevelTestScoreId: undefined,
    });
    props.setTests(newArray);
  };

  const options = getFilter(props.testNames);
  const scores = getFilter(props.testScores);
  return (
    <TableContainer component={Paper}>
      <Table className={classes.table} aria-label="customized table">
        <TableHead>
          <TableRow>
            <StyledTableCell>Subject</StyledTableCell>
            <StyledTableCell size="small">Score</StyledTableCell>
            <StyledTableCell />
          </TableRow>
        </TableHead>
        <TableBody>
          {props.tests.map((row, index) => (
            <Row
              scores={scores}
              options={options}
              test={row}
              delete={() => deleteTest(index)}
              setTest={(newActivity: ALevelTest) =>
                updateTests(index, newActivity)
              }
              key={index}
            />
          ))}
          <StyledTableRow>
            <StyledTableCell colSpan={3}>
              <RoundedButton
                variant="outlined"
                style={{
                  borderRadius: "30px",
                  color: "white",
                  border: "none",
                  margin: "auto",
                }}
                buttonStyle="primary"
                onClick={addTest}
              >
                <Typography
                  variant="body1"
                  style={{
                    fontSize: "16px",
                    fontFamily: "SuperaGothic",
                    lineHeight: "normal",
                  }}
                >
                  Add
                </Typography>
              </RoundedButton>
            </StyledTableCell>
          </StyledTableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
}

function getFilter(items: Array<FilterLineItem>): Array<Option> {
  const options = items.map((item) => {
    return {
      key: item.id,
      value: item.name || String(item.score),
    };
  });
  return options;
}
